<template>
  <div id="app">
    <h3 @click="back" style="border-bottom:1px solid #ccc;padding:0px 0 10px 10px;cursor:pointer">返回</h3>
    <div v-show="result.length > 0">
      <div class="title">比对网站</div>
      <div class="web">{{webTitle}}</div>
      <div class="count">相似处({{result.length}}处)</div>
      <table class="table">
        <tr>
          <th class="img">相似图</th>
          <th class="link">链接</th>
        </tr>
        <tr v-for="(item,key) in result" :key="key">
          <td><img :src="item.targetPic"/></td>
          <td><a :href="item.targetLink" target="_blank">{{item.targetLink}}</a></td>
        </tr>
      </table>
    </div>
    <div v-show="result.length == 0 && !isLoading">未监测出结果，请耐心等待</div>
      <div v-show="isLoading">正在加载...</div>
  </div>
</template>
<script>
import {taskDetailApi} from  '@/service/allApi'
export default {
  data(){
    return {
      taskId:0,
      wid:0,
      webTitle:'',
      result:[],
      isLoading:true
    }
  },
  mounted() {
    this.taskId = this.$route.query.taskId
    this.wid = this.$route.query.wid
    this.loadData()
  },

  methods: {
    back(){
      window.history.back(-1); 
    },
    async loadData(){
      this.isLoading = true
      const options =  {
        taskId:this.taskId,
        wid:this.wid
      }
      const res = await taskDetailApi(options)
      this.isLoading = false
      // console.log(res)
      if(res.data.code == 100){
        this.webTitle = res.data.data.title
        if(res.data.data.results){
          this.result = res.data.data.results
        }
      }
    }
  },
}
</script>
<style scoped>

.title{
  text-align: center;
  color: #5353ce;
  font-size: 20px;
  padding: 20px 0;
}
.web{
  font-size: 14px;
  color: #222222;
  padding-bottom: 20px;
  border-bottom:1px solid #f2f2f2;
  text-align: center;
}
.count{
  	color: #5353ce;
  font-size: 14px;
  line-height:30px;
  border-bottom: 1px solid #f2f2f2;
  padding-left: 20px;
}
.table {
  padding-left: 20px;
  width: 100%;
}
.table tr th.img{
  width: 130px;
}
.table tr th{
  border-bottom: 1px solid #f2f2f2;
  font-size: 14px;
  color: #5353ce;
  line-height: 40px;
}
.table tr td{
  padding:10px;
}
.table tr td img{
  width: 128px;
  height: 128px;
}
</style>


// WEBPACK FOOTER //
// src/components/iframe/ResultView.vue